<template>
  <div
    ref="trigger"
    v-click-outside="handleClickOutside"
    class="relative flex items-center justify-end cursor-pointer"
    @click="open = !open"
  >
    <button class="flex items-center justify-center px-3 h-9 gap-2 hover:bg-secondary-subtle rounded-md border border-transparent hover:border-secondary-subtle duration-200 hover:text-secondary group text-sm">
      <span>Show <span class="text-gray-900 !font-medium">{{ model }}</span> / page</span>
      <i class="fa-regular fa-chevron-down text-center" />
    </button>

    <div
      v-if="open"
      ref="floating"
      :style="floatingStyles"
      class="absolute min-w-36 bg-white shadow top-10 right-0 rounded border z-10"
    >
      <span
        v-for="option in options"
        :key="option"
        class="block w-full text-gray-600 no-underline px-2.5 py-2 text-sm hover:bg-gray-100"
        @click="selectItemsPerPage(option)"
      >
        <span class="text-gray-900 !font-medium">{{ option }}</span> / page
      </span>
    </div>
  </div>
</template>

<script setup>
import { flip, offset, shift, useFloating } from '@floating-ui/vue';
import { ref } from 'vue';

const options = [10, 20, 50];

// Define model to replace emit and props for itemsPerPage
const model = defineModel({
  type: Number,
  default: 10,
});

const open = ref(false);
const trigger = ref();
const floating = ref();
const { floatingStyles } = useFloating(trigger, floating, {
  middleware: [offset(10), flip(), shift()],
});

const handleClickOutside = () => {
  open.value = false;
};

const selectItemsPerPage = option => {
  model.value = option; // This automatically updates the parent model
  open.value = false;
};
</script>
